function ClientSelector() {
  return <div>Select which client to use for this session.</div>; // @TODO
}

export default ClientSelector;
